import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from 'components/Header';
import NavPanel from 'components/NavPanel';

class Layout extends Component {

  constructor(props) {
    super(props);
    this.state = { active: '', nav: '' };
  }

  toggleNav = () => {
    if (this.state.active == 'active') {
      this.setState({ active: '', nav: '' })
    } else
      this.setState({ active: 'active', nav: 'icon-w60 panel-open' })
  }

  render() {
    return (
      <section className="layout-wrapper">
        <Header active={this.state.active} clicker={this.toggleNav} lang={this.props.lang} contentType={this.props.contentType} queryTerm={this.props.queryTerm} queryType={this.props.queryType} querySlug={this.props.querySlug}></Header>
        <section className="layout-2-columns">
          <NavPanel clicker={this.toggleNav} nav={this.state.nav} contentType={this.props.contentType} queryTerm={this.props.queryTerm} queryResource={this.props.queryResource} queryType={this.props.queryType} querySlug={this.props.querySlug} lang={this.props.lang}></NavPanel>
          <section className="layout-content">
            <main className="mCustomScrollbar" data-mcs-theme="dark">
              {this.props.children}
            </main>
          </section>
        </section>
      </section>
    );
  }
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default Layout



// WEBPACK FOOTER //
// ./src/components/Layout.jsx